import { isDefined } from './array';

const TWO_HOURS = 7200;

type Vehicle = {
  vehicleUnlockDateTime?: string;
};

export default function getPurchaseStatus(vehicle: Vehicle) {
  if (!isDefined(vehicle.vehicleUnlockDateTime)) {
    return {
      isLocked: false,
      isOnHold: false
    };
  }

  const timeLeft = Date.parse(vehicle.vehicleUnlockDateTime) - Date.now();

  // in case the unlock time is in the past
  if (timeLeft < 0) {
    return {
      isLocked: false,
      isOnHold: false
    };
  }

  return {
    isLocked: Math.floor(timeLeft / 1000) >= TWO_HOURS,
    isOnHold: Math.floor(timeLeft / 1000) < TWO_HOURS
  };
}
